import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import Grid from '@material-ui/core/Grid';
import { useDispatch, useSelector } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import FieldNode from '../fields/FieldNode';
import { CloseSquare } from '../../atoms/Tree/Icons';
import ActionIcons from '../../atoms/Tree/ActionIcons';
import { StyledTreeItem } from '../../atoms/Tree/Component';
import { setElementToCopy, handleSnackBar, handleTopRightInfo } from '../../../store/global/actions';
import { getElementToCopy, getElementOnFocus, getlatestFieldAdded, getNodeExpanded } from '../../../store/global/selectors';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import IconButton from '@material-ui/core/IconButton';
import { invokeGetService, invokePostService } from '../../../store/global/actions'
import { toggleRightDrawer, setFocusElement, setReRender } from '../../../store/global/actions';
import { findParentIds } from '../../../config/fields';

const useStyles = makeStyles({
  root: {
    height: '100%',
    minHeight: 500,
    flexGrow: 2,
    maxWidth: 400,
    //overflowX: 'scroll'
  },
});

const scrollToTheTop = () => {
  // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  var myDiv = document.getElementById('bcrumb');
  if(myDiv) myDiv.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

}




/** Individual section node */
export const SectionItem = ({ section, setAction, index, totalNumberSections, allFields, onSuccess }) => {

  const dispatch = useDispatch();
  const elementToCopy = useSelector(getElementToCopy);
  const elementOnFocus = useSelector(getElementOnFocus);
  const sectionFields = allFields.filter(field => field.parent[0].id === section._id);
  let fieldName = '';


  const copyItem = ({ id, ...rest }) => {
    dispatch(setElementToCopy({ id, type: 'section' }));
    dispatch(handleSnackBar({ open: true, message: "Item copied", severity: "success" }));
  }

  const pasteItem = ({ id, ...rest }) => {
    dispatch(handleTopRightInfo({ message: "Updating section..", open: true, }));
    const rootParent = elementOnFocus.id;
    const rootParentType = elementOnFocus.type;
    dispatch(invokePostService('pasteField', { fieldId: elementToCopy.id, parentId: section._id, parentType: 'section', rootParent, rootParentType }, [])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Section updated", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          setAction({});
        }
      }
    });

  }


  let actions = {
    add: { id: section._id, action: 'create_field', tooltip: 'Add a field', item: 'section', perform: setAction },
    // edit: { id: section.id, action: 'edit_section', tooltip: 'Edit property', item: 'section', perform: setAction },
    delete: { id: section._id, action: 'delete_section', tooltip: 'Delete section', item: 'section', perform: setAction },
    copy: { id: section._id, action: 'copy_section', tooltip: 'Copy this section', item: 'section', perform: copyItem }
  }

  if (elementToCopy != null && elementToCopy.type == 'field') {
    actions = { ...actions, paste: { id: section.id, tooltip: 'Paste copied item', perform: pasteItem } }
  }

  const fieldHolder = {
    'display': 'inline-block',
    'white-space': 'nowrap',
    'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    'vertical-align': 'top',
    'paddingLeft': '10px',
    'paddingTop': '10px',
    'paddingBottom': '10px'
    // 'borderRight': 'solid 1px #ccc',
  }

  const setActionEdit = (e) => {
    setAction({ action: 'edit_section', id: section._id, item: section })
    if (e.target.closest('li') !== undefined && e.target.closest('li').classList.contains('Mui-expanded') == true) {
      e.preventDefault();
    }
  }

  const moveSectionUp = (sectionID) => {
    dispatch(handleTopRightInfo({ message: "Moving section..", open: true, }));

    dispatch(invokePostService('moveSection', { direction: 'up', clusterletId: elementOnFocus.id }, [sectionID])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Section moved", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          dispatch(toggleRightDrawer());
          dispatch(setReRender());
          dispatch(setFocusElement({}));
        }
      }
    });
  }

  const moveSectionDown = (sectionID) => {
    dispatch(handleTopRightInfo({ message: "Moving section..", open: true, }));

    dispatch(invokePostService('moveSection', { direction: 'down', clusterletId: elementOnFocus.id }, [sectionID])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Section moved", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          dispatch(toggleRightDrawer());
          dispatch(setReRender());
          dispatch(setFocusElement({}));
        }
      }
    });
  }

  const sortArrowStyle = {
    fontSize: 14,
    margin: 'auto',
    color: '#4791db'
  }

  const buttonContainerStyle = {
    paddingTop: '10px',
    paddingBottom: '10px'
  }

  const fieldItemContainer={
    paddingRight: '10px'
  }

  return (
    <Grid container spacing={12} style={fieldItemContainer}>
      <Grid item xs={8} style={fieldHolder} alignItems="left" onClick={e => { setActionEdit(e); scrollToTheTop(); }} className={`field_node_${section.name}`} >{section.name}</Grid>

      <Grid item xs={2} justify="flex-end" style={buttonContainerStyle}>
        <ActionIcons actions={actions} />
      </Grid>

      <Grid item xs={1} style={buttonContainerStyle}>
        {index > 0 && <Tooltip title="Move up">
          <IconButton onClick={e => moveSectionUp(section._id)}>
            <ArrowUpwardIcon style={sortArrowStyle} />
          </IconButton>
        </Tooltip>}
      </Grid>

      <Grid item xs={1} style={buttonContainerStyle}>
        {index < totalNumberSections - 1 && <Tooltip title="Move down">
          <IconButton onClick={e => moveSectionDown(section._id)}><ArrowDownwardIcon style={sortArrowStyle} /></IconButton></Tooltip>}
      </Grid>
    </Grid>


  )
}


/** Root label for section tree */
const SectionRootLabel = ({ content, parent, setAction, sections, allSections, onSuccess }) => {
  const dispatch = useDispatch();
  const elementToCopy = useSelector(getElementToCopy);
  const elementOnFocus = useSelector(getElementOnFocus);
  let sectionName = '';

  const pasteItemToRoot = ({ id, ...rest }) => {
    dispatch(handleTopRightInfo({ message: "Updating properties..", open: true, }));
    dispatch(invokePostService('pasteSection', { sectionId: elementToCopy.id, clusterletId: elementOnFocus.id }, [])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Properties updated", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          dispatch(toggleRightDrawer());
          dispatch(setReRender());
          dispatch(setFocusElement({}));
        }
      }
    });
  }

  let actions = {
    add: { id: parent.id, action: 'create_section', tooltip: 'Add a section', item: 'section', perform: setAction }
  }
  if (elementToCopy != null && elementToCopy.type == 'section') actions = { ...actions, paste: { id: parent.id, tooltip: 'Paste copied item', perform: pasteItemToRoot } }

  return (
    <Grid container spacing={5} style={{padding: '10px'}}>
      <Grid item xs alignItems="left" >{content}</Grid>
      <Grid item xs justify="flex-end">
        {/* {elementToCopy != null && elementToCopy.type == 'section' && <ActionIcons actions={actions} />} */}
        <ActionIcons actions={actions} disableBorder={true} />
      </Grid>
    </Grid>
  )
}

const ProfileRootLabel = ({ content, parent, setAction, sections, allSections, onSuccess }) => {

  const dispatch = useDispatch();
  const elementToCopy = useSelector(getElementToCopy);
  const elementOnFocus = useSelector(getElementOnFocus);
  let sectionName = '';

  const pasteItemToRoot = ({ id, ...rest }) => {
    dispatch(handleTopRightInfo({ message: "Updating properties..", open: true, }));
    dispatch(invokePostService('pasteSection', { sectionId: elementToCopy.id, clusterletId: parent.id }, [])).then(res => {
      dispatch(handleTopRightInfo({ open: false }));
      if (res?.status) {
        dispatch(handleSnackBar({ open: true, message: "Properties updated", severity: "success" }));
        setAction({});
        onSuccess();
      } else {
        if (res?.code === 255) {
          setAction({});
        }
      }
    });

  }

  const onProfileClick = (e) => {
    if (parent && parent.id !== undefined) {
      e.preventDefault();
    } 
    setAction({ action: 'edit_profile', id: parent._id, item: parent });
  }

  let actions = {
    //paste: { id: null, tooltip: 'Paste copied item', perform: pasteItemToRoot }
    add: { id: parent.id, action: 'create_section', tooltip: 'Add a section', item: 'section', perform: setAction }
  }
  if (elementToCopy != null && elementToCopy.type == 'section') actions = { ...actions, paste: { id: parent._id, tooltip: 'Paste copied item', perform: pasteItemToRoot } }

  return (
    <Grid container spacing={5} style={{padding: '10px'}}>
      <Grid item xs alignItems="left" onClick={onProfileClick}>{content}</Grid>
      <Grid item xs justify="flex-end">
        {/* {elementToCopy != null && elementToCopy.type == 'section' && <ActionIcons actions={actions} />} */}
        <ActionIcons actions={actions} disableBorder={true} />
      </Grid>
    </Grid>
  )
}



export default function SectionTree({ parent, setAction, profile, action, itemToExpand, refreshTree, setRefreshTree }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const latestAddedFields = useSelector(getlatestFieldAdded);

  const [sections, setSections] = useState([]);
  const [allSections, setAllSections] = useState([]);
  const [allFields, setAllFields] = useState([]);
  const [profileData, setProfileData] = useState(undefined);
  const [expandNodes, setExpandNodes] = useState(['1']);
  const nodeExpanded = useSelector(getNodeExpanded);
  const [selectedNodeItem, setSelectedNodeItem] = useState(null);


  function expandNode(id) {
    setExpandNodes([...expandNodes, id])
  }

  function collapseNode(id) {
    setExpandNodes(expandNodes?.filter(item => item != id))
  }
  useEffect(() => {
    dispatch(invokeGetService('getClusterletProperties', [parent.id, profile ? true : false])).then(res => {
      if (res?.status == true) {
        const allSectionsArray = res?.data?.allSections ? res?.data?.allSections : [];
        const allFieldsArray = res?.data?.allFields ? res?.data?.allFields : []
        setSections(res?.data?.sections ? res?.data?.sections : []);
        setAllFields(allFieldsArray);
        setAllSections(allSectionsArray);
        setProfileData(res?.data?.profile != null && res?.data?.profile !== undefined ? res?.data?.profile : undefined);

        let sectionIds = res?.data?.sections?.map(item => item._id);
        sectionIds = sectionIds !== undefined ? sectionIds : [];

        if (action && action.id) {
          let parentNodes = findParentIds(allSectionsArray, allFieldsArray, action.id)
          setExpandNodes(["1", action.id, ...parentNodes])
        }
        else {
          setExpandNodes([...expandNodes, ...sectionIds?.filter(e => !expandNodes.includes(e))]);
        }

        // if (nodeExpanded != "") {
        //   if (itemToExpand != null || itemToExpand != undefined) {
        //     setExpandNodes(["1", nodeExpanded, itemToExpand])
        //   } else {
        //     setExpandNodes(["1", nodeExpanded])
        //   }
        // } else {
        //   setExpandNodes([...expandNodes, ...sectionIds?.filter(e => !expandNodes.includes(e))]);
        // }
        // else setExpandNodes([...expandNodes, ...sectionIds?.filter(e => !expandNodes.includes(e)), ...latestAddedFields?.filter(e => !expandNodes.includes(e))]);


      } else {
        if (res?.code === 255) {
          dispatch(toggleRightDrawer());
          dispatch(setReRender());
          dispatch(setFocusElement({}));
        }
      }
    });
  }, [refreshTree, nodeExpanded])

  return (

    <>
      <Grid id={"clusterlet_tree_container"} row>
        <TreeView
          className={classes.root}
          expanded={expandNodes}
          defaultEndIcon={<CloseSquare />}
          fullWidth={true}
          id="section_tree"
        // selected={selectedNodeItem}
        >



          <StyledTreeItem nodeId="1" collapseNode={collapseNode} expandNode={expandNode} label={profile === true ? <ProfileRootLabel sections={sections} allSections={allSections} content={`${parent.name} (${sections.length})`} parent={{ id: profileData?._id }} setAction={setAction} onSuccess={() => setRefreshTree(c => c + 1)}/> : <SectionRootLabel allSections={allSections} sections content={`Sections (${sections.length})`} parent={parent} setAction={setAction} onSuccess={() => setRefreshTree(c => c + 1)}/>} >

            {sections.sort((a, b) => a.order - b.order).map((section, index) => {
              return (
                <StyledTreeItem nodeId={section._id} collapseNode={collapseNode} expandNode={expandNode} label={<SectionItem allFields={allFields} section={section} setAction={setAction} index={index} totalNumberSections={sections.length} onSuccess={() => setRefreshTree(c => c + 1)}/>} >
                  {allFields.filter(field => field.parent[0].id == section._id).sort((a, b) => a.order - b.order).map((field, fieldIndex) => {
                    return (<FieldNode allFields={allFields} collapseNode={collapseNode} expandNode={expandNode} field={field} setAction={setAction} index={fieldIndex} totalFields={allFields.filter(field => field.parent[0].id == section._id).length} onSuccess={() => setRefreshTree(c => c + 1)}/>)
                  })}

                </StyledTreeItem>
              )

            })}

          </StyledTreeItem>


        </TreeView>
      </Grid>
    </>
  );
}